var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKpiBackground = function SvgKpiBackground(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 211,
    fill: "none",
    viewBox: "0 0 230 211",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#kpi-background_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M182.101 206.896c29.525-21.43 47.439-55.555 47.439-92.547C229.54 51.193 178.256 0 115 0 51.745 0 .46 51.193.46 114.349c0 38.727 19.23 74.083 50.74 95.119a7.636 7.636 0 1 0 8.48-12.702c-27.3-18.224-43.948-48.834-43.948-82.417 0-54.716 44.441-99.077 99.268-99.077s99.268 44.361 99.268 99.077c0 32.031-15.517 61.591-41.138 80.187a7.636 7.636 0 0 0 8.971 12.36Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kpi-background_svg__a",
    width: 229.08,
    height: 212.587,
    x: 0.46,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.665
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.048514 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_22071_63536"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKpiBackground);
export default ForwardRef;